import { Helmet } from "react-helmet-async";

const SITE_NAME  = "Donald Stephen Inbody";
const SITE_URL   = process.env.REACT_APP_FRONTEND_URL || window.location.origin;
const DEFAULT_IMG = "https://customer-assets.emergentagent.com/job_morse-chronicles/artifacts/tfncxvd5_Don%20Inbody%20Navy.jpg";

const DEFAULT_DESCRIPTION =
  "Donald Stephen Inbody — retired U.S. Navy Captain, political scientist, and author. Author of The Soldier Vote (Palgrave Macmillan) and the forthcoming naval fiction series The Morse Chronicles, beginning with Wake of the Falcon — featuring Captain Hank Morse aboard USS Wichita in the Dutch East Indies in August 1914. Military voting expert, amateur radio operator (ADØK), and Americana musician with BuffaloGrass. Not affiliated with InBody Co., Ltd. (inbody.com).";

// Extra keywords injected for Naval History category posts
const NAVAL_HISTORY_KEYWORDS =
  "WWI Naval History, Historical Accuracy, Naval Warfare, Naval Fiction, Donald Stephen Inbody, naval historian";

export default function SEO({
  title,
  description,
  keywords      = "",
  canonical,
  ogType        = "website",
  noIndex       = false,
  category,       // blog post category
  postTitle,      // for blog post structured data
  publishedAt,
}) {
  const isNavalHistory = category === "Naval History";

  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} — Author, Naval Historian & Political Scientist`;

  const metaDescription = description || DEFAULT_DESCRIPTION;

  const allKeywords = [
    "Donald Stephen Inbody",
    "Donald Inbody",
    "Don Inbody",
    "The Soldier Vote",
    "The Morse Chronicles",
    "Wake of the Falcon",
    "Captain Hank Morse",
    "USS Wichita",
    "naval historian",
    "political scientist",
    "military voting",
    "ADØK",
    "BuffaloGrass",
    "inbody.net",
    isNavalHistory ? NAVAL_HISTORY_KEYWORDS : "",
    keywords,
  ]
    .filter(Boolean)
    .join(", ");

  const canonicalUrl = canonical || SITE_URL;

  return (
    <Helmet>
      {/* ── Core ── */}
      <title>{fullTitle}</title>
      <meta name="description"            content={metaDescription} />
      <meta name="keywords"               content={allKeywords} />
      <meta name="author"                 content="Donald Stephen Inbody" />
      <link rel="canonical"               href={canonicalUrl} />
      {noIndex && <meta name="robots"     content="noindex, nofollow" />}

      {/* ── Open Graph ── */}
      <meta property="og:type"            content={ogType} />
      <meta property="og:site_name"       content={SITE_NAME} />
      <meta property="og:title"           content={fullTitle} />
      <meta property="og:description"     content={metaDescription} />
      <meta property="og:url"             content={canonicalUrl} />
      <meta property="og:image"           content={DEFAULT_IMG} />
      <meta property="og:locale"          content="en_US" />

      {/* ── Twitter Card ── */}
      <meta name="twitter:card"           content="summary_large_image" />
      <meta name="twitter:title"          content={fullTitle} />
      <meta name="twitter:description"    content={metaDescription} />
      <meta name="twitter:image"          content={DEFAULT_IMG} />

      {/* ── Disambiguation: inbody.net ≠ inbody.com ── */}
      <meta name="disambiguate" content="This domain, Inbody.net, as well as Don Inbody and his family have no connection to the company doing business as InBody or to the Inbody.com domain. Don Inbody has had Inbody.net registered since at least November 2000. Donald Stephen Inbody is an author, naval historian, and political scientist. InBody Co., Ltd. (inbody.com) is a South Korean body composition technology company. These are entirely separate and unrelated entities." />

      {/* ── Naval History extra tags ── */}
      {isNavalHistory && (
        <meta name="subject" content="WWI Naval History, Historical Accuracy, Naval Warfare" />
      )}

      {/* ── Blog post Article meta ── */}
      {ogType === "article" && publishedAt && (
        <meta property="article:published_time" content={publishedAt} />
      )}
      {ogType === "article" && (
        <meta property="article:author" content="Donald Stephen Inbody" />
      )}
    </Helmet>
  );
}
